// extracted by mini-css-extract-plugin
export default {"logoImage":"styles_logoImage__6kx9Y","title":"styles_title__f2KNo","line":"styles_line__vqCkQ","resend":"styles_resend__go-t-","disabled":"styles_disabled__K6N+W"};